import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserHistory } from "history";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import store from "./store/configureStore";
import { Provider as ReduxProvider } from "react-redux";
import LocalServiceWorkerRegister from './serviceWorkerRegister';


const baseUrl = document.getElementsByTagName("base")[0]?.getAttribute("href");
// Create browser history to use in the Redux store
// eslint-disable-next-line no-unused-vars
const history = createBrowserHistory({ basename: baseUrl });

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ReduxProvider store={store}>
    <Router>
      <App />
    </Router>
  </ReduxProvider>
);


if (process.env.NODE_ENV === "production") {
  LocalServiceWorkerRegister();
}
